import type { CSSProperties } from 'react'

// Skill 页主视觉和 4 张能力预览图都和首页放在同一个 OSS 目录，后续如果产品替图，只需要改这里的文件名。
const SKILL_IMAGE_BASE_URL = 'https://cdn.aitubiao.com/static/images/itubiao/landingpage'

// 跑马灯条带图标走独立目录，与产品提供的 SVG 文件名一一对应。
const SKILL_RIBBON_ICON_BASE_URL = 'https://cdn.aitubiao.com/static/images/skill'

// Hero 的底色单独走渐变，图片本身只承载右侧主视觉，后续替成透明底资源也不用再改结构。
export const HERO_VISUAL_IMAGE = `${SKILL_IMAGE_BASE_URL}/skill-bg.png`

// 已包含能力区现在按单图链接驱动，每张卡片后续如果要换图，只需要改这里对应的 URL。
export const SKILL_MULTI_CHART_PREVIEW_IMAGE = `${SKILL_IMAGE_BASE_URL}/skill-multiple-chart.png`
export const SKILL_REPORT_PREVIEW_IMAGE = `${SKILL_IMAGE_BASE_URL}/skill-big-screen.png`
export const SKILL_SANKEY_PREVIEW_IMAGE = `${SKILL_IMAGE_BASE_URL}/skill-sankey.png`
export const SKILL_3D_PREVIEW_IMAGE = `${SKILL_IMAGE_BASE_URL}/skill-3d-chart.png`

export const COPY_ICON_24 = 'https://www.figma.com/api/mcp/asset/1010d27e-7704-4aca-89ca-afb0352e243d'
export const COPY_ICON_30 = 'https://www.figma.com/api/mcp/asset/f9cb0081-42a5-4022-a9c6-9a581c723ceb'

export type SkillRibbonItem = {
  label: string
  iconSrc: string
  width: number
  iconSize: number
  fontSize: number
  style: CSSProperties
}

export type IncludedSkillItem = {
  name: string
  title: string
  description: string
  previewImage: string
  prompt: string
  downloadUrl: string | null
}

export type FAQItem = {
  question: string
  answer: string
}

export const marqueeSkillRows: SkillRibbonItem[][] = [
  [
    {
      label: '管理驾驶舱',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/guanli.svg`,
      width: 218.09,
      iconSize: 32.727,
      fontSize: 32.73,
      style: {
        backgroundImage: 'linear-gradient(180deg, #1FE891 0%, #1BD884 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(46,218,140,0.33)'
      }
    },
    {
      label: '经营分析',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/jingying.svg`,
      width: 192.99,
      iconSize: 32.661,
      fontSize: 32.66,
      style: {
        backgroundImage: 'linear-gradient(180deg, #3B72FF 0%, #4B9BFF 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(77,179,255,0.4)'
      }
    },
    {
      label: '周报月报',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/zhoubao.svg`,
      width: 205,
      iconSize: 43.636,
      fontSize: 32.73,
      style: {
        backgroundImage: 'linear-gradient(180deg, #FF9C41 0%, #FFDB74 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.97), 0px 3px 10px rgba(255,176,82,0.44)'
      }
    },
    {
      label: '汇报总结',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/huibao.svg`,
      width: 196.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #9868FF 0%, #B07CFF 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(170,32,255,0.33)',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    },
    {
      label: '论文整理',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/lunwen.svg`,
      width: 196.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #3B72FF 0%, #4B9BFF 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(77,179,255,0.4)',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    },
    {
      label: '研究展示',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/yanjiu.svg`,
      width: 196.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #FF6216 0%, #FFDB74 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.95), 0px 3px 10px rgba(255,115,37,0.3)'
      }
    }
  ],
  [
    {
      label: '活动复盘',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/huodong.svg`,
      width: 197.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #9868FF 0%, #B07CFF 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(170,32,255,0.33)',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    },
    {
      label: '投放分析',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/toufang.svg`,
      width: 197.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #FF6216 0%, #FFDB74 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.95), 0px 3px 10px rgba(255,115,37,0.3)'
      }
    },
    {
      label: '媒体传播',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/meiti.svg`,
      width: 195.877,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #3B72FF 0%, #4B9BFF 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(77,179,255,0.4)',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    },
    {
      label: '客户方案',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/kehu.svg`,
      width: 196.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #1FE891 0%, #1BD884 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px rgba(46,218,140,0.33)',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    },
    {
      label: '课程作业',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/kecheng.svg`,
      width: 196.364,
      iconSize: 36,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #1BAFC9 0%, #37FBF8 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px #9BF7FE',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    },
    {
      label: '答辩汇报',
      iconSrc: `${SKILL_RIBBON_ICON_BASE_URL}/dabian.svg`,
      width: 202.364,
      iconSize: 42,
      fontSize: 24,
      style: {
        backgroundImage: 'linear-gradient(180deg, #4837FB 0%, #6F63FF 100%)',
        boxShadow: '0px 2px 6.4px rgba(255,255,255,0.94), 0px 3px 10px #B3ACFF',
        border: '1px solid rgba(0,0,0,0.1)'
      }
    }
  ]
]

export const includedSkillItems: IncludedSkillItem[] = [
  {
    name: '生成多个图表',
    title: '生成多个图表',
    description: '适合根据报表一次性输出多个相关图表、减少重复操作',
    previewImage: SKILL_MULTI_CHART_PREVIEW_IMAGE,
    prompt: ['请安装爱图表的「生成多个图表」Skill', 'Skill 链接：https://clawhub.ai/aitubiao/aitubiao-ai-chart'].join('\n'),
    downloadUrl: 'https://wry-manatee-359.convex.site/api/v1/download?slug=aitubiao-ai-chart'
  },
  {
    name: '生成数据汇报',
    title: '生成数据汇报',
    description: '适合阶段汇报、经营总结和数据复盘等场景，把关键数据整理成更易讲述的内容。',
    previewImage: SKILL_REPORT_PREVIEW_IMAGE,
    prompt: ['请安装爱图表的「生成数据汇报」Skill', 'Skill 链接：https://clawhub.ai/aitubiao/aitubiao-ppt'].join('\n'),
    downloadUrl: 'https://wry-manatee-359.convex.site/api/v1/download?slug=aitubiao-ppt'
  },
  {
    name: '生成桑基图',
    title: '桑基图',
    description: '想要表现流向和交叉数据的桑基图，不用操作 Excel，上传数据帮你直接出图。',
    previewImage: SKILL_SANKEY_PREVIEW_IMAGE,
    prompt: ['请安装爱图表的「生成桑基图」Skill', 'Skill 链接：https://clawhub.ai/aitubiao/aitubiao-sankey'].join('\n'),
    downloadUrl: 'https://wry-manatee-359.convex.site/api/v1/download?slug=aitubiao-sankey'
  },
  {
    name: '生成3D图表',
    title: '生成3D图表',
    description: '把数据转换成更有空间感和立体感的 3D 图表，适合做更吸睛的展示内容。',
    previewImage: SKILL_3D_PREVIEW_IMAGE,
    prompt: ['请安装爱图表的「生成3D图表」Skill', 'Skill 链接：https://clawhub.ai/aitubiao/aitubiao-3d-chart-illustration'].join('\n'),
    downloadUrl: 'https://wry-manatee-359.convex.site/api/v1/download?slug=aitubiao-3d-chart-illustration'
  }
]

export const faqItems: FAQItem[] = [
  {
    question: '使用 Skill 和直接在官网上使用爱图表，有什么区别？',
    answer:
      '直接在官网使用，更适合需要完整编辑、反复调整和最终导出的场景；安装 Skill，则更适合在你常用的 AI 工具中快速调用爱图表能力，减少切换和重复操作。你可以根据自己的使用习惯，选择更适合当前场景的方式。'
  },
  {
    question: '安装完成后，我怎么使用不同的 Skill？',
    answer: '安装完成后，你可以根据当前任务直接调用对应能力。比如需要批量生成多个图表时，用“生成多个图表”；需要做流向分析时，用“生成桑基图”。'
  },
  {
    question: '我需要提前准备什么类型的数据？',
    answer: '常见的表格数据、统计结果或其他结构化信息都可以直接使用。不同 Skill 适合处理的内容略有差异，安装完成后可根据当前任务按需使用对应能力。'
  },
  {
    question: '如果我只想安装其中一个 Skill，可以吗？',
    answer: '可以。你可以进入对应 Skill 卡片，单独复制该 Skill 的安装提示词进行安装；如果希望更省事，也可以直接一键安装全部 Skill，后续按需使用。'
  },
  {
    question: '安装完成后，我还需要重复安装吗？',
    answer: '不需要。完成一次安装后，后续可按需直接使用，不需要每次都重新复制和配置。'
  },
  {
    question: '全部安装会不会让使用变复杂？',
    answer: '不会。一次安装只是先把常用能力配齐，后续你仍然是按场景使用，不想用的 Skill 放着也不会影响正常使用。'
  }
]

// 全量安装提示词统一复用各个 Skill 的 ClawHub 地址，避免页面卡片和复制文案出现分叉。
export const allSkillPrompt = [
  '请安装爱图表的全部 Skills：',
  '- 生成多个图表：https://clawhub.ai/aitubiao/aitubiao-ai-chart',
  '- 生成桑基图：https://clawhub.ai/aitubiao/aitubiao-sankey',
  '- 生成数据汇报：https://clawhub.ai/aitubiao/aitubiao-ppt',
  '- 生成 3D 图表：https://clawhub.ai/aitubiao/aitubiao-3d-chart-illustration'
].join('\n')
